<template>
	<template v-for="(item, index) in options" :key="index">
		<search-address
			v-if="item.type === 'searchAddress'"
			:data="item"
		></search-address>
		<inputComp v-if="item.type === 'input'" :data="item" />
		<datePickerComp v-if="item.type === 'datePicker'" :data="item" />
		<selectComp v-if="item.type === 'select'" :data="item" />
		<span style="padding: 0 5px"></span>
	</template>
</template>

<script>
import inputComp from "./children/input.vue";
import datePickerComp from "./children/datePicker.vue";
import selectComp from "./children/select.vue";
import SearchAddress from "../searchAddress/search-address.vue";
export default {
	name: "SearchComp",
	components: {
		inputComp,
		datePickerComp,
		selectComp,
		SearchAddress,
	},
	props: {
		options: {
			type: Array,
			default() {
				return [];
			},
		},
	},
};
</script>

<style scoped>
.a {
}
</style>
